import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import "@bms-ai/bms-ai-ui-lib/styles.css";
import './index.css'
import RemoteApp from './RemoteApp.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RemoteApp />
  </StrictMode>,
)
